import React from "react";
import { Box, Typography } from "@mui/material";
import DashboardCard from "./DashboardCard";
import { DASH, STATUS_COLORS } from "../dashboardTheme";

const STAGES = [
  { key: "pending", label: "Pendientes", status: "PENDING" },
  { key: "scheduled", label: "Programados", status: "SCHEDULED" },
  { key: "inProgress", label: "En progreso", status: "IN_PROGRESS" },
  { key: "completed", label: "Completados", status: "COMPLETED" },
];

export default function ServicePipeline({
  pipeline,
  pipelineTotal,
  completionRate,
  eventStats,
  loading,
}) {
  const eventByStatus = (eventStats?.byStatus || []).reduce((acc, s) => {
    acc[s._id] = s.count;
    return acc;
  }, {});

  const cancelled = eventByStatus.CANCELLED ?? 0;
  const postponed = eventByStatus.POSTPONED ?? 0;

  return (
    <DashboardCard
      title="Pipeline de servicios"
      subtitle={
        loading
          ? "Cargando..."
          : `${pipelineTotal.toLocaleString("es-MX")} en el sistema`
      }
      sx={{ mb: 3 }}
    >
      {loading ? (
        <Box className="dash-skeleton" sx={{ height: 80 }} />
      ) : (
        <>
          <Box sx={{ mb: 2.5 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
              <Typography sx={{ fontSize: "11px", fontWeight: 500, color: DASH.textMuted, letterSpacing: "0.06em", textTransform: "uppercase" }}>
                Tasa de completación
              </Typography>
              <Typography
                sx={{
                  fontFamily: DASH.fontMono,
                  fontSize: "13px",
                  fontWeight: 500,
                  color: DASH.text,
                }}
              >
                {completionRate}%
              </Typography>
            </Box>
            <Box
              sx={{
                height: 3,
                borderRadius: 999,
                bgcolor: DASH.borderLight,
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: `${completionRate}%`,
                  bgcolor: DASH.text,
                  borderRadius: 999,
                  transition: "width 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
              gap: 0,
              border: `1px solid ${DASH.borderLight}`,
              borderRadius: DASH.radiusSm,
              overflow: "hidden",
            }}
          >
            {STAGES.map(({ key, label, status }, idx) => {
              const count = pipeline[key] ?? 0;
              const pct = pipelineTotal > 0 ? Math.round((count / pipelineTotal) * 100) : 0;
              const colors = STATUS_COLORS[status];

              return (
                <Box
                  key={key}
                  sx={{
                    p: 2,
                    borderRight: idx < STAGES.length - 1 ? `1px solid ${DASH.borderLight}` : "none",
                    borderBottom: { xs: idx < 2 ? `1px solid ${DASH.borderLight}` : "none", md: "none" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 1 }}>
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        bgcolor: colors.bar,
                        opacity: status === "COMPLETED" ? 1 : 0.5,
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "11px",
                        fontWeight: 500,
                        letterSpacing: "0.04em",
                        color: DASH.textMuted,
                      }}
                    >
                      {label}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: DASH.fontMono,
                      fontSize: "1.375rem",
                      fontWeight: 500,
                      color: DASH.text,
                      lineHeight: 1,
                      letterSpacing: "-0.03em",
                    }}
                  >
                    {count.toLocaleString("es-MX")}
                  </Typography>
                  <Typography sx={{ fontSize: "11px", color: DASH.textMuted, mt: 0.5 }}>
                    {pct}%
                  </Typography>
                </Box>
              );
            })}
          </Box>

          {(cancelled > 0 || postponed > 0) && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 2 }}>
              {cancelled > 0 && (
                <Typography sx={{ fontSize: "11px", color: DASH.textMuted, fontWeight: 500 }}>
                  {cancelled} cancelados este mes
                </Typography>
              )}
              {postponed > 0 && (
                <Typography sx={{ fontSize: "11px", color: DASH.textMuted, fontWeight: 500 }}>
                  {postponed} pospuestos este mes
                </Typography>
              )}
            </Box>
          )}
        </>
      )}
    </DashboardCard>
  );
}
